import React from "react";
import { useNavigate } from "react-router";
import useQueryParams from "../../hooks/useQueryParams";

const isBillingReport = title => {
  return (
    title?.includes("Billing Report (Prototype)") ||
    title?.includes("Billing Report (Validation)") ||
    title?.includes("Multi-project billing report")
  );
};

export default function NotificationLink({ value: notification }) {
  const navigate = useNavigate();
  const queryParams = useQueryParams();
  const isBilling = isBillingReport(notification.title);

  const handlePreview = e => {
    e.preventDefault();
    e.stopPropagation();
    const newParams = new URLSearchParams(queryParams);
    if (notification.ownerId) {
      newParams.set("ownerId", notification.ownerId);
    }
    navigate({
      pathname: `/insights/reports/${notification.id}`,
      search: newParams.toString(),
    });
  };

  if (!notification.link) {
    return notification.title;
  }

  // For billing reports, route to the dedicated full-screen viewer
  if (isBilling) {
    return (
      <a href="#" onClick={handlePreview} style={{ cursor: "pointer" }}>
        {notification.title}
      </a>
    );
  }

  // For non-billing reports, show regular download link
  return (
    <a target="_blank" href={notification.link}>
      {notification.title}
    </a>
  );
}
